import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import { INFO_MESSAGE_TEXT } from 'components/MyGarage2.0/constants'

const InformationalMessage = ({ className, closeInfoMessage }) =>
  <Wrapper className={ className }>
    <AlertIcon asset="alert-orange" alt="Alert icon" />

    <Text>
      {INFO_MESSAGE_TEXT}
    </Text>

    <CloseButton onClick={ closeInfoMessage }>
      X
    </CloseButton>
  </Wrapper>

InformationalMessage.propTypes = {
  className: PropTypes.string,
  closeInfoMessage: PropTypes.func
}

export default InformationalMessage

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 12px 68px 12px 40px;
  border-radius: 2px;
  background-color: ${Theme.colors.light_grey_background};

  @media (max-width: 500px) {
    padding: 12px 40px 12px 35px;
  }
`

const AlertIcon = styled(Icon)`
  position: absolute;
  left: 12px;
  top: 12px;
  width: 16px;
  height: 16px;
`

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 500;
`

const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 8px;
  padding: 3px;
  cursor: pointer;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 300;
  border: none;
  background-color: ${Theme.colors.light_grey_background};
  transform: translateY(-50%);

  &:hover {
    background-color: ${Theme.colors.light_grey};
  }
`
